import * as yup from 'yup';
import {
  DistributionReasonDTO,
  DistributionReasonValueDTO,
} from '../../../../api/useWithdrawalOptionsQuery';

export const PRIMARY_DISTRIBUTION_REASONS = [
  DistributionReasonValueDTO.Normal,
  DistributionReasonValueDTO.Premature,
  DistributionReasonValueDTO.ExcessContributionRemovalBeforeTaxDeadline,
];

export const PRIMARY_DISTRIBUTION_REASON_DESCRIPTION = {
  [DistributionReasonValueDTO.Normal]:
    'Now that I am over 59.5 years old, I would like to withdraw from my IRA.',
  [DistributionReasonValueDTO.Premature]:
    'Since I am not yet 59.5 years old and I understand that taxes and early withdrawal penalties may be assessed by the IRS.',
  [DistributionReasonValueDTO.ExcessContributionRemovalBeforeTaxDeadline]:
    'To keep total contributions for the year less than the maximum allowed, based on my age and adjusted gross income.',
};

export const DISTRIBUTION_REASONS_TITLES: Record<DistributionReasonValueDTO, string> = {
  [DistributionReasonValueDTO.Normal]: 'Normal Distribution',
  [DistributionReasonValueDTO.Disability]: 'Disability',
  [DistributionReasonValueDTO.ExcessContributionRemovalBeforeTaxDeadline]:
    'Removing Excess Contribution',
  [DistributionReasonValueDTO.ExcessContributionRemovalAfterTaxDeadline]:
    'Excess contribution after tax deadline',
  [DistributionReasonValueDTO.RolloverToQualifiedPlan]: 'Rollover to qualified plan',
  [DistributionReasonValueDTO.RolloverToIra]: 'Rollover to IRA',
  [DistributionReasonValueDTO.Transfer]: 'Transfer',
  [DistributionReasonValueDTO.RecharacterizationPriorYear]: 'Recharacterization of prior year',
  [DistributionReasonValueDTO.RecharacterizationCurrentYear]: 'Recharacterization of current year',
  [DistributionReasonValueDTO.Conversion]: 'Conversion',
  [DistributionReasonValueDTO.ManagementFee]: 'Management fee',
  [DistributionReasonValueDTO.PrematureSimpleIraLessThan2Years]:
    'Premature Simple IRA less than 2 years',
  [DistributionReasonValueDTO.NormalRothIraGreaterThan5Years]:
    'Normal Roth IRA greater than 5 years',
  [DistributionReasonValueDTO.Premature]: 'Premature Distribution',
  [DistributionReasonValueDTO.Death]: 'Death',
};

export interface FormValues {
  distributionReason: DistributionReasonDTO | null;
}

export const validation = yup.object().shape({
  distributionReason: yup
    .object()
    .nullable()
    .required('You need to select a distribution reason'),
});
